import { services } from "onearm";
import { GameStates } from "onearm";
import { SubGameState } from "./game/states/SubGameState";

export class SystemSettingsPopupState extends SubGameState {
    async enter() {
        super.enter();

        this.bets = services.get("bets");
        this.currencyFormatter = services.get("currencyFormatter");

        this.systemSettingsPopupScene = this.scenes.add('SystemSettingsPopupScene', {
            bet: this.bets.totalBet,
            currencyFormatter: this.currencyFormatter,
            isMusicMuted: this.data.isMusicMuted,
            isSfxMuted: this.data.isSfxMuted,
            musicVolume: this.data.musicVolume,
            sfxVolume: this.data.sfxVolume,
            volume: this.data.volume,
            isSoundsMuted: this.data.isSoundsMuted,
            isQuickSpin: this.data.quickSpin,
        });
        this.audio = services.get("audio");

        this.scenes.show("SystemSettingsPopupScene");

        this.addSignalHandler(this.systemSettingsPopupScene.onPressClose, this.handlePressClose);
        this.addSignalHandler(
            this.systemSettingsPopupScene.onChangeQuickSpin,
            this.handleChangeQuickSpin,
        );
        this.addSignalHandler(
            this.systemSettingsPopupScene.onChangeAmbientMusic,
            this.handleChangeAmbientMusic,
        );
        this.addSignalHandler(
            this.systemSettingsPopupScene.onChangeSoundFX,
            this.handleChangeSoundFX,
        );
        this.addSignalHandler(
            this.systemSettingsPopupScene.onChangeIntroScreen,
            this.handleChangeIntroScreen,
        );
        this.addSignalHandler(this.systemSettingsPopupScene.onPressMinus, this.handlePressMinus);
        this.addSignalHandler(this.systemSettingsPopupScene.onPressPlus, this.handlePressPlus);
        this.addSignalHandler(
            this.systemSettingsPopupScene.onPressGameHistory,
            this.handlePressGameHistory,
        );
        this.addSignalHandler(this.systemSettingsPopupScene.onPressHome, this.handlePressHome);
        this.addSignalHandler(this.bets.onTotalBetChanged, this.handleBetChanged);
    }

    handleBetChanged(bet) {
        this.systemSettingsPopupScene.setBet(bet);
    }

    handlePressClose() {
        this.owner.goTo(GameStates.IDLE);
    }

    handleChangeQuickSpin(value) {
        this.data.quickSpin = value;
    }

    handleChangeAmbientMusic(value) {
        this.data.isMusicMuted = !value;
        this.audio.muteMusic(!value);
    }

    handleChangeSoundFX(value) {
        this.data.isSfxMuted = !value;
        this.audio.muteSfx(!value);
    }

    handleChangeIntroScreen(value) {
        this.data.dontShowAgainGameIntro = !value;
    }

    handlePressMinus() {
        this.bets.previousBet();
    }

    handlePressPlus() {
        this.bets.nextBet();
    }

    handlePressGameHistory() {
        console.log("Game History link pressed");
        // TODO: Implement game history navigation
    }

    handlePressHome() {
        console.log("Home link pressed");
        // TODO: Implement home navigation
    }

    exit() {
        super.exit();
        this.scenes.hide("SystemSettingsPopupScene");
        this.scenes.remove("SystemSettingsPopupScene");
    }
}
